export default from './NotAuthorised';



// WEBPACK FOOTER //
// ./src/views/NotAuthorised/index.js